// extracted by mini-css-extract-plugin
module.exports = {"parentContainer":"tableStyles__parentContainer___vKNeT","childContainer":"tableStyles__childContainer___fTdH3"};